import { Link } from "react-router-dom";
import SoftButton from "components/SoftButton";
import { useTranslation } from "react-i18next";
import { Box, Card, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import logo from "assets/images/logo.png";
import LanguageSwitcher from "../../../reusableComponents/LanguageSwitcher/LanguageSwitcher";
import { useTheme } from "@mui/material/styles";
import background from "../../../assets/images/curved-images/background.jpg";

function Confirmation() {
    const theme = useTheme();
    const { i18n } = useTranslation();
    const { t } = useTranslation(["confirmation"]);
    const currentLang = i18n.language;
    const dir = i18n.dir();

    const backLink = `/${currentLang}/authentication/sign-in`;

    const [animateCard, setAnimateCard] = useState(false);
    const [animateTitle, setAnimateTitle] = useState(false);
    const [animateImage, setAnimateImage] = useState(false);
    const [animateLogo, setAnimateLogo] = useState(false);

    useEffect(() => {
        setTimeout(() => setAnimateLogo(true), 300);
        setTimeout(() => setAnimateImage(true), 400);
        setTimeout(() => setAnimateTitle(true), 500);
        setTimeout(() => setAnimateCard(true), 700);
    }, []);

    return (
        <>
            <Grid container sx={{ minHeight: "100vh", overflow: "hidden" }} dir={dir}>
                <Grid
                    item
                    xs={12}
                    md={6}
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        p: 5,
                        backgroundColor: "#ffffff",
                        position: "relative",
                    }}
                >
                    <Box
                        sx={{
                            position: "absolute",
                            top: theme.spacing(2),
                            left: theme.spacing(2),
                            right: theme.spacing(2),
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            zIndex: 10,
                        }}
                    >
                        <Box
                            sx={{
                                opacity: animateLogo ? 1 : 0,
                                transform: animateLogo ? "translateY(0)" : "translateY(-10px)",
                                transition: "all 0.8s ease",
                            }}
                        >
                            <img src={logo} alt="YaiGlobal Logo" style={{ height: 48 }} />
                        </Box>
                        <LanguageSwitcher />
                    </Box>

                    <Box sx={{ width: "100%", maxWidth: 480 }}>
                        <Card
                            elevation={6}
                            sx={{
                                borderRadius: 4,
                                px: 5,
                                py: 6,
                                backdropFilter: "blur(12px)",
                                backgroundColor: "rgba(255, 255, 255, 0.65)",
                                border: "1px solid rgba(255, 255, 255, 0.4)",
                                boxShadow: "0 8px 24px rgba(0, 0, 0, 0.15)",
                                opacity: animateCard ? 1 : 0,
                                transform: animateCard ? "translateY(0)" : "translateY(10px)",
                                transition: "all 0.7s ease",
                                textAlign: "center"
                            }}
                        >
                            <Typography
                                variant="h4"
                                fontWeight="bold"
                                sx={{
                                    background: "linear-gradient(to right, #d946ef, #ec4899)",
                                    WebkitBackgroundClip: "text",
                                    WebkitTextFillColor: "transparent",
                                    mb: 1,
                                    opacity: animateTitle ? 1 : 0,
                                    transform: animateTitle ? "translateX(0)" : "translateX(-10px)",
                                    transition: "all 0.7s ease",
                                }}
                            >
                                {t("content.title")}
                            </Typography>

                            <Typography
                                variant="body2"
                                color="textSecondary"
                                sx={{
                                    mb: 3,
                                    opacity: animateTitle ? 1 : 0,
                                    transform: animateTitle ? "translateX(0)" : "translateX(-10px)",
                                    transition: "all 0.8s ease",
                                }}
                            >
                                {t("content.description")}
                            </Typography>

                            <Typography variant="body2" color="textSecondary">
                                {t("content.note")}
                            </Typography>

                            <SoftButton
                                component={Link}
                                to={backLink}
                                variant="gradient"
                                color="primary"
                                fullWidth
                                sx={{ mt: 3 }}
                            >
                                {t("content.backToLogin")}
                            </SoftButton>
                        </Card>
                    </Box>

                </Grid>
                <Grid item md={6} sx={{display: {xs: "none", md: "block"}, position: "relative", overflow: "hidden"}}>
                    <Box
                        sx={{
                            width: "100%",
                            height: "100%",
                            backgroundImage: `url(${background})`,
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            opacity: animateImage ? 1 : 0,
                            transition: "opacity 1s ease",
                        }}
                    />

                    {/* Light Overlay to Further Brighten */}
                    <Box
                        sx={{
                            position: "absolute",
                            inset: 0,
                        }}
                    />
                </Grid>
            </Grid>
        </>
    );
}

export default Confirmation;